module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--7-b31a5def2d466ef63681ce3a068c69b9.jpg";